// extracted by mini-css-extract-plugin
export default {"crumb":"BreadCrumb_crumb__jyiZM","link":"BreadCrumb_link__k9h2x"};